export function PodcastIcon({
  className = "size-5",
}: {
  className?: string;
}) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M11.7925 13.9272C13.5288 12.753 14.668 10.7991 14.668 8.58169C14.668 4.98714 11.6826 2.073 8.00003 2.073C4.3175 2.073 1.33203 4.98714 1.33203 8.58169C1.33203 10.7991 2.4713 12.753 4.20752 13.9272M5.30295 10.9637C4.67992 10.3339 4.29559 9.4883 4.29559 8.55618C4.29559 6.61251 5.95429 5.03656 8.00003 5.03656C10.0458 5.03656 11.7045 6.61251 11.7045 8.55618C11.7045 9.48894 11.3201 10.3339 10.6971 10.9637M8.74092 8.74101C8.74092 9.15019 8.40921 9.4819 8.00003 9.4819C7.59085 9.4819 7.25914 9.15019 7.25914 8.74101C7.25914 8.33182 7.59085 8.00012 8.00003 8.00012C8.40921 8.00012 8.74092 8.33182 8.74092 8.74101Z" stroke="#101828" stroke-width="1.336" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}

export const displayName = "PodcastIcon";
